import { render, staticRenderFns } from "./IdealPayments.vue?vue&type=template&id=15fe96d0&scoped=true&"
import script from "./IdealPayments.vue?vue&type=script&lang=js&"
export * from "./IdealPayments.vue?vue&type=script&lang=js&"
import style0 from "./IdealPayments.vue?vue&type=style&index=0&id=15fe96d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe96d0",
  null
  
)

export default component.exports